/*
*  Pass a date string into the function and return the age
*  dateString = MM/DD/YYYY
---------------------
*/

export function getAge(dateString) {
    const today = new Date(),
        birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear(),
        m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    // console.log(age);
    return age;
}